/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MockLiquidationHelper,
  MockLiquidationHelperInterface,
} from "../MockLiquidationHelper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lens",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "enum MockLiquidationHelper.LiquidationScenario",
        name: "_scenario",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "address",
            name: "sellToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "buyToken",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "swapCallData",
            type: "bytes",
          },
        ],
        internalType: "struct MockLiquidationHelper.SwapInput0x[]",
        name: "_swapsInputs0x",
        type: "tuple[]",
      },
    ],
    name: "executeLiquidation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lens",
    outputs: [
      {
        internalType: "contract SiloLens",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shareAmountsToRepaid",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "siloLiquidationCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type MockLiquidationHelperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockLiquidationHelperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockLiquidationHelper__factory extends ContractFactory {
  constructor(...args: MockLiquidationHelperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "MockLiquidationHelper";
  }

  deploy(
    _repository: string,
    _lens: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MockLiquidationHelper> {
    return super.deploy(
      _repository,
      _lens,
      overrides || {}
    ) as Promise<MockLiquidationHelper>;
  }
  getDeployTransaction(
    _repository: string,
    _lens: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_repository, _lens, overrides || {});
  }
  attach(address: string): MockLiquidationHelper {
    return super.attach(address) as MockLiquidationHelper;
  }
  connect(signer: Signer): MockLiquidationHelper__factory {
    return super.connect(signer) as MockLiquidationHelper__factory;
  }
  static readonly contractName: "MockLiquidationHelper";
  public readonly contractName: "MockLiquidationHelper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockLiquidationHelperInterface {
    return new utils.Interface(_abi) as MockLiquidationHelperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockLiquidationHelper {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as MockLiquidationHelper;
  }
}
